function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgModelo = function SvgModelo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M24.266 3.763a6.976 6.976 0 016.852 7.02c0 3.37-1.552 5.903-4.565 6.816v10.897L23.986 31.5h-3.65v-3.423l1.304-1.03v-.575l-1.305-1.238v-1.3l1.305-1.474v-.6l-1.305-1.03v-3.931c-2.113-1.254-3.26-3.492-3.26-6.116A6.972 6.972 0 0123.2 3.816a4.065 4.065 0 10-6.514 4.654l-.7.714a5.065 5.065 0 118.279-5.421zm-.744 1.024c-3.085.283-5.448 2.83-5.448 5.996 0 2.379 1.058 4.346 2.997 5.383l.264.14v4.04l1.305 1.03v1.462l-1.305 1.475v.492l1.305 1.238v1.488l-1.305 1.03V30.5h2.19l2.028-2.373v-11.3l.38-.094c2.776-.69 4.185-2.869 4.185-5.95 0-3.213-2.433-5.787-5.583-6.007.04.257.061.52.061.79v.854a2.457 2.457 0 11-1 0v-.855c0-.266-.026-.526-.074-.778zm.574 5.496a1.456 1.456 0 100-2.913 1.456 1.456 0 000 2.913zm-15 10.88l6.82-6.82.708.706-7.528 7.528-8.533-8.534 8.978-8.978h4.12v1H9.955l-7.978 7.978 7.12 7.12z"
  }));
};

SvgModelo.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgModelo.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgModelo;